export default "__VITE_ASSET__CnF9$rhh__"